// extracted by mini-css-extract-plugin
export default {"wrap":"NotFoundPage_wrap__dE+9C","code":"NotFoundPage_code__oink+","actions":"NotFoundPage_actions__DFs57"};